import React, { forwardRef } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';
import { messages } from './messages';

export const Service = forwardRef((props, ref) => {
  const appliedFiltersCount = useSelector((state) =>
    Global.selectOrdersFilteringActiveFilterViewFiltersById(state, {
      filterById: props.filterById,
    }),
  )?.length;

  return (
    <ActionableFilterPill
      {...props}
      ref={ref}
      displayContent={<FormattedMessage {...messages.service} values={{ appliedFiltersCount }} />}
      isSelected={!!appliedFiltersCount}
    />
  );
});

Service.propTypes = {
  filterById: PropTypes.string,
};
